import { render, staticRenderFns } from "./WarningClusterCard.vue?vue&type=template&id=70cf89bc&scoped=true"
import script from "./WarningClusterCard.vue?vue&type=script&lang=js"
export * from "./WarningClusterCard.vue?vue&type=script&lang=js"
import style0 from "./WarningClusterCard.vue?vue&type=style&index=0&id=70cf89bc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf89bc",
  null
  
)

export default component.exports